import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request } from '../services/data-service';
import { Api } from '../services/api';
import { FormatBytes } from './machine-schemas';

@inject(DataService, Api, Router)
export class MachineAppendData{
	/** MARK: Component methods
		============================================
	 **/
	constructor(ds, api, router){
		this.ds			= ds;
		this.api		= api;
		this.router 	= router;
		this.file		= "";
		this.formatBytes = FormatBytes;
	}
	activate(params){ this.id = params.id }
	attached(){ window.setTimeout( () => { this.init(); }, 300);}

	init(){
		let machine = this.ds.app_data.machine;
		if(machine){
			this.machine = machine;

		}
		else{
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				this.handleMachineResponse(response);
			})
		}
	}
	/**	MARK: API calls
		============================================
	**/
	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;
		if(status === 200){
			let machine  = response.data;
			this.machine = machine
			this.ds.app_data.machine = machine;
		};
	}

	/**	MARK: Custom methods
		============================================
	**/

	uploadFile(){
		// Response dataset
		let response_dataset;
		let dataset_document = {
			name	: this.file.name,
			size	: this.file.size,
			uid		: this.ds.user.uid,
			type	: "source"
		};

		// Current dataset target
		let id 			= this.machine._id;
		let request 	= new Request("/api/v2/datasets/id/_id?", "PUT");
		let params  	= new URLSearchParams({ _id:id });
		request.url 	= request.url + params;
		this.readFile(this.file).then(f => {
			if(f){
				let file		= f;
				let body		= {
					"dataset": dataset_document,
					"file":file,
					"oper":"upload_dataset",
					"src_dataset_name":this.machine.dataset
				};
				console.log("req => ", request.body);
				request.body 	= JSON.stringify(body);
				return this.api.put(request);
			}
			else{
				return new Promise(resolve => { resolve(400)});
			}
		})
		.then(response => {
			console.log("response upload file => ", response);
		});
	}// end upload

	readFile(file){
		if(file){
			let fr = new FileReader();
			// Read as URL
			// Add event listener
			fr.addEventListener('loadstart', this.frChangeStatus('Start loading'));
			fr.addEventListener('load', this.frChangeStatus('Loaded'));
			fr.addEventListener('loadend', this.frLoaded);
			fr.addEventListener('progress', this.frSetProgress);
			fr.addEventListener('error', this.frErrorHandler);
			fr.addEventListener('abort', this.frChangeStatus('Interrupted'));

			return new Promise(resolve => {
				fr.readAsDataURL(file);
				fr.onload = () => { resolve(fr.result);};
			});
		}
		else{
			return new Promise(resolve => { resolve(null);});
		}
	}
	
	onSelectFile($event){this.file = $event.target.files[0];}
	frChangeStatus(status){console.log("status: ", status);}

	frLoaded(e){
		let file = e.target
		this.fileStream = file.result;
	}
	frSetProgress(e){}
	frErrorHandler(e){}

	/** MARK: Action / Transition methods
		============================================
	 **/
	done(){
		this.uploadFile();
		window.setTimeout( () => {
			this.router.navigateToRoute('models.data', { id :this.id })
		}, 1000);

	}
}
